// extracted by mini-css-extract-plugin
export default {"projectIcon":"projectIcon__MAuIlu"};